<template>
  <div v-if="betRanks">
    <div class="h5">
      <span v-if="betPeriod.running" class="text-sakali-primary">Live </span>
      Tippschein Rangliste
      <fas id="friendsToggle"
           icon="user-friends"
           size="sm"
           :title="filter === 'fo' ? 'klicken, um alle Trainer anzuzeigen' : 'klicken, um nur Freunde anzuzeigen'"
           class="ms-2"
           :class="{'text-sakali-primary': filter === 'fo'}"
           @click="filter === 'fo' ? filter = '' : filter = 'fo'"/>
      <fas id="leagueToggle"
           size="sm"
           icon="list-ol"
           :title="filter === 'lo' ? 'klicken, um alle Trainer anzuzeigen' : 'klicken, um Trainer Deiner Liga anzuzeigen'"
           class="ms-1"
           :class="{'text-sakali-primary': filter === 'lo'}"
           @click="filter === 'lo' ? filter = '' : filter = 'lo'"/>
      <span class="ps-3 text-muted small text-sakali-primary">
                <span v-if="filter === 'lo'">Deine Liga</span>
                <span v-if="filter === 'fo'">nur Freunde</span>
            </span>
    </div>
    <div class="card-sakali container">
      <bet-rank-entry
          v-for="rank in betRanks"
          :key="rank.user.id"
          :live="betPeriod.running"
          :rank="rank"
          :show-user="filter !== 'lo'"
          :show-team="filter === 'lo'"/>
    </div>
  </div>
</template>

<script>

import {mapActions, mapGetters} from "vuex";
import sakaliApi from "../../sakali-api";
import BetRankEntry from "./BetRankEntry";

export default {
  props: {
    betPeriod: Object
  },
  data() {
    return {
      betRanks: Array,
      filter: 'none'
    }
  },
  computed: {
    ...mapGetters(['user'])
  },
  methods: {
    ...mapActions(['handleErrorAction']),
    loadBetRanking() {
      sakaliApi.get('/betslipranking/' + this.betPeriod.number, {
        params: {
          f: this.filter
        }
      }).then(response => {
        this.betRanks = response.data
      }).catch(error => {
        this.handleErrorAction(error)
      })
    }
  },
  watch: {
    ...mapActions(['handleErrorAction']),
    betPeriod() {
      this.loadBetRanking();
    },
    filter() {
      this.loadBetRanking();
    }
  },
  components: {
    BetRankEntry
  },
  mounted() {
    this.loadBetRanking();
  }
}

</script>
